import React, {cloneElement} from 'react'
import PropTypes from 'prop-types'
import {Flex, Text, useStyleConfig} from '@chakra-ui/react'
import {useBooleanCustomPreference} from '../../hooks/use-custom-preference'

const StockLabel = ({icon, textMessage, variant = ''}) => {
    const styles = useStyleConfig('StockLabel', {variant})
    const notShoppableCountry = useBooleanCustomPreference('notShoppableCountry')

    if (notShoppableCountry) {
        return
    }

    return (
        <Flex {...styles.container}>
            <Text {...styles.text}>{textMessage}</Text>
            {cloneElement(icon, {...styles.icon})}
        </Flex>
    )
}

StockLabel.propTypes = {
    icon: PropTypes.node.isRequired,
    textMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    variant: PropTypes.string,
}

export default StockLabel
